"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    dataTapeSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Data tape slug'),
    msrTapeSlug: (0, tape_builder_base_1.zArtifactSlugRef)('MSR tape slug').optional(),
    // Optional so graphs saved before the flag existed parse; absent = off.
    enableDataLake: zod_1.z
        .boolean()
        .optional()
        .describe('Write the accepted data tape to the cross-deal bus_loan_level datalake tables (adds a busUploadToDatalake node after the approval gate)'),
});
exports.nodeType = 'file_reconciledBusTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'reconciledBusTape';
//# sourceMappingURL=types.js.map